module.exports = new __parcel__URL__("level_2_tab_active.1bff64c1.png").toString();